<ui-section
    [title]="config.translations.widgetTitle + ' ' + (isCostIndicatorCode ? ('STUFF.' + (vatMode$ | async) | translate) : '')"
    [subtitle]="
        (displayMode === ExpenditureModes.BAR_GRAPH_MODE
            ? 'PAGES.BUILDING_HOME.ENERGY_BALANCE_GRAPH_MODE'
            : displayMode === ExpenditureModes.BAR_GRAPH_ACCRUE_MODE
              ? 'PAGES.BUILDING_HOME.ENERGY_BALANCE_GRAPH_ACCRUE_MODE'
              : 'PAGES.BUILDING_HOME.ENERGY_BALANCE_TABLE_MODE'
        ) | translate
    "
>
    <ui-section-actions>
        <div class="advizeo-toolbar spaced-toolbar">
            <degree-day-selector #degreeDaySelector [forMonoBuilding]="isMonoBuilding$ | async" />
            <energy-expenditure-balance-selector
                #selector
                [autoSelectFromLocalStorage]="!config.defaultMode"
                [defaultMode]="config.defaultMode"
                (modeSelected)="onModeSelect($event)"
            />
            @if (isCostIndicatorCode && (canAccessToBudget$ | async)) {
                <button
                    ui-button
                    color="primary"
                    iconName="go-to"
                    buttonStyle="outline"
                    size="small"
                    class="no-print"
                    (click)="goToEditBudget()"
                >
                    {{ 'WIDGET.BUDGET' | translate }}
                </button>
            }
        </div>
    </ui-section-actions>
    <ui-section-content>
        <energy-expenditure-balance
            [indicatorCode]="this.indicatorCode$ | async"
            [displayMode]="selector.displayModeSelected"
            [selectedDegreeDayIndicators]="degreeDaySelector.currentSelection"
            [ordinateTitle]="config.translations.ordinateTitle"
            [universeIds]="config.universeIds"
        />
    </ui-section-content>
</ui-section>
